import { ACTION_TYPES } from "../../actions/common/NavigationActions"
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import update from 'immutability-helper'

const initialState = {
    routeList:
        [
            {
                path: '/',
                linkLegend: 'Home',
                urlParams: []
            }
        ]
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.ADD_ROUTE:
            const path = action.payload.path
            const navIndex = state.routeList.findIndex((obj) => obj.path === path)
            if (navIndex > -1) {
                state.routeList.splice(navIndex, state.routeList.length)
                const updatedNav = update(state.routeList, { $splice: [[navIndex, 1, action.payload]] })
                return {
                    ...state,
                    routeList: updatedNav
                }
            } else {
                return {
                    ...state,
                    routeList: [...state.routeList, action.payload]
                }
            }
        case ACTION_TYPES.CLEAN_ROUTES:
            return {
                ...state,
                routeList:
                    [
                        {
                            path: '/',
                            linkLegend: 'Home',
                            urlParams: []
                        }
                    ]
            }
        default:
            return state
    }
}

const persistConfig = {
    key: 'nav',
    storage,
}

const NavigationReducer = persistReducer(persistConfig, reducer);

export default NavigationReducer